<template>
  <div :data-id="researcher.id">
    <div class="list-group-item-figure align-items-start mr-1">
      <a href="#" class="user-avatar">
        <img :src="researcher.avatar"
             :alt="researcher.full_name"></a>
    </div>
  
    <div class="list-group-item-body">
      <h4 class="list-group-item-title">
        <a href="#">
          <template v-if="researcher.invited_by_email && !showName">
              {{ researcher.email }} <small class="text-muted">(invitación vía correo electrónico)</small>
          </template>
          <template v-else>
            {{ researcher.full_name }}
          </template>
        </a>
      </h4>
      <p class="list-group-item-text">
        <span class="badge"
              :class="getStatusClasses(researcher)">{{ getStatusTitle(researcher) }}</span>
      </p>
    
      <template v-if="!researcher.invited_by_email">
        <div class="mt-3" v-if="(researcher.added_on_protocol && markAsRemoved) || researcher.added_on_amendment">
          <label :for="`justificacion_${researcher.id}`"
                class="d-block">
            Justificación
          </label>
        
          <textarea rows="3" cols="3"
                    :id="`justificacion_${researcher.id}`"
                    :name="`justificacion_${researcher.id}`"
                    :data-researcher="researcher.id"
                    :disabled="disableJustification(researcher)"
                    v-model="researcher.pivot.justification"
                    placeholder="Justificación"
                    class="form-control"></textarea>
        </div>
      </template>
    </div>
  
    <div class="list-group-item-figure align-items-start" v-if="showActions">
      <div class="dropdown">
        <button class="btn btn-sm btn-icon btn-light"
                data-toggle="dropdown">
          <i class="fa fa-fw fa-ellipsis-v"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-arrow mr-n1"></div>
        
          <button type="button"
                  class="dropdown-item"
                  @click="markResearcherAsRemoved(researcher)"
                  ref="btn-remove-researcher">Eliminar coinvestigador
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import autosize from 'autosize'
  
  export default {
    name: 'ResearcherListItem',
    props: {
      researcher: Object,
      showActions: {
        type: Boolean,
        default: true,
      },
      showName: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        markAsRemoved: false,
      }
    },
    methods: {
      async markResearcherAsRemoved (researcher) {
        researcher.mark_as_removed = true
        this.markAsRemoved = true
  
        this.$emit('remove-researcher', researcher)
      },
      getStatusClasses (researcher) {
        if (researcher.invited_by_email) {
          return {
            'badge-success': researcher.is_accepted,
            'badge-danger': researcher.is_accepted === false,
            'badge-warning': researcher.is_accepted === null
          }
        }

        return {
          'badge-success': researcher.status.key === 'aceptado',
          'badge-warning': researcher.status.key === 'enviado',
          'badge-danger': researcher.status.key === 'rechazado',
          'badge-dark': researcher.status.key === 'cancelado' || researcher.status.key === 'ignorado',
        }
      },
      getStatusTitle (researcher) {
        if (researcher.invited_by_email) {
          switch(researcher.is_accepted) {
            case true:
              return 'Petición aceptada por el coinvestigador.'
            case false:
              return 'Petición rechazada por el coinvestigador.'
            case null:
              return 'Petición enviada al coinvestigador.'
          }
          console.log('exit switch')
        }

        return researcher.status.title
      },
      disableJustification (researcher) {
        return researcher.added_on_amendment && (this.readonly || researcher.pivot.status.key === 'aceptado')
      },
    },
    mounted() {
      autosize($('textarea'))
    }
  }
</script>

<style scoped lang="scss">
  textarea {
    resize: none;
  }
</style>
